import React, { FC, useCallback } from 'react';
import { IconButton, TableRow } from '@material-ui/core';
import TableCell from 'src/components/TableCell';
import { LegacyEmployee } from 'src/interfaces/api/Employee';
import { MdDelete as DeleteIcon } from '@react-icons/all-files/md/MdDelete';
import { GetEmployeeStatsReponse } from '../../hooks/useEmployeeStats';
import { numberWithSpaces } from '../../../../../../../../utils/NumberUtils';

interface Props {
  onRemoveRow: () => void;
  employee: LegacyEmployee;
  stats: GetEmployeeStatsReponse;
}

const EmployeeRow: FC<Props> = ({ onRemoveRow, employee, stats }) => {
  const getDealsConvertion = useCallback((): string => {
    const won = parseInt(stats.dealsWonCount || '0');
    const lost = parseInt(stats.dealsLostCount || '0');

    if (won + lost === 0) {
      return '0';
    }

    return ((won / (won + lost)) * 100).toFixed(2);
  }, [stats]);

  return (
    <TableRow>
      <TableCell>
        {employee.firstname} {employee.lastname}
      </TableCell>
      <TableCell>{stats.appointmentDoneCount || 0}</TableCell>
      <TableCell>{stats.customersCreatedCount || 0}</TableCell>
      <TableCell>{stats.dealsCreatedCount || 0}</TableCell>
      <TableCell>{numberWithSpaces(parseFloat(stats.dealsCreatedPDC || '0'))}€</TableCell>
      <TableCell>{stats.dealsWonCount || 0}</TableCell>
      <TableCell>{numberWithSpaces(parseFloat(stats.dealsWonPDC || '0'))}€</TableCell>
      <TableCell>{stats.dealsLostCount || 0}</TableCell>
      <TableCell>{getDealsConvertion()}</TableCell>
      <TableCell>
        <IconButton onClick={onRemoveRow}>
          <DeleteIcon size={16} color='#F00' />
        </IconButton>
      </TableCell>
    </TableRow>
  );
};

export default EmployeeRow;
